<template>
  <div class="app">
    <AppLayoutEvents
      v-if="events && !loading"
      :data="events" :isNewVersion="isNewVersion"
      :filterByTracksAndHalls="filterByTracksAndHalls"
      :lang="lang" :type="type" :year="year"/>
    <AppLayoutMembers
      v-if="members && !loading" :data="members"
      :isNewVersion="isNewVersion"
      :lang="lang" :type="type" :year="year"/>
    <AppLoader v-if="loading"/>
  </div>
</template>
<script>

import AppLayoutEvents from '@/components/app-layout-events/app-layout-events.vue';
import AppLayoutMembers from '@/components/app-layout-members/app-layout-members.vue';
import AppLoader from '@/components/app-loader/app-loader.vue';
import _get from 'lodash.get';

export default {
  name: 'App',
  components: {
    AppLayoutEvents,
    AppLayoutMembers,
    AppLoader,
  },
  data() {
    return {
      program: true,
      memberShow: false,
      activeMember: false,
      events: undefined,
      members: undefined,
      loading: false,
      state: 'members', // events, members
      trekId: null, // '01', '01,02'
      excludeTrekId: false, // true если исключаем указанные в trekId треки
      type: 'innoprom', // bioprom, biotechmed, innofood, innoprom, tashkent
      year: '2025',
      lang: 'ru',
      isNewVersion: true,
      filterByTracksAndHalls: true,
    };
  },
  methods: {
    async getEventsData() {
      const config = {
        params: {
          lang: this.lang,
        },
      };
      if (this.trekId) {
        let trekIdsArray = [];

        if (this.trekId.includes(',')) {
          trekIdsArray = this.trekId.split(',').map((id) => id.trim());
        }

        if (this.excludeTrekId) {
          config.params['!trek'] = trekIdsArray.length > 0 ? trekIdsArray : this.trekId;
        } else {
          config.params.trek = trekIdsArray.length > 0 ? trekIdsArray : this.trekId;
        }
      }
      if (this.year) {
        config.params.year = this.year;
      }
      if (this.type) {
        config.params.type = this.type;
      }
      try {
        this.loading = true;
        const result = await this.$api.get('/api/program/get', config);
        if (result) {
          this.events = _get(result, 'data.data.record', null);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getMembersData() {
      let filters = false;
      if (localStorage.filters) {
        filters = JSON.parse(localStorage.filters);
      }
      const config = {
        params: {
          count: 20,
          lang: this.lang,
        },
      };

      if (this.year) {
        config.params.year = this.year;
      }
      if (this.type) {
        config.params.type = this.type;
      }

      if (filters) {
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(filters)) {
          config.params[key] = value;
        }
      }
      try {
        this.loading = true;
        const result = await this.$api.get('/api/participants/get', config);
        if (result) {
          this.members = _get(result, 'data.data.record', null);
          this.$set(this.members, 'lang', this.lang);
          this.loading = false;
        }
      } catch (error) {
        // this.loading = false;

        console.log(error);
      }
    },
  },
  created() {
    const langs = ['ru', 'en'];
    let currentLang;

    if (process.env.NODE_ENV === 'production') {
      this.state = document.getElementById('app').dataset.state;

      const root = document.getElementById('app');

      if (root.hasAttribute('data-trek-id')) {
        this.trekId = root.getAttribute('data-trek-id');
        this.excludeTrekId = root.hasAttribute('data-trek-id-exclude');
      }

      this.isNewVersion = root.hasAttribute('data-type-new-version');
      this.filterByTracksAndHalls = root.hasAttribute('data-filter-tracks-halls');

      if (root.hasAttribute('data-year')) {
        this.year = root.getAttribute('data-year');
      }

      if (root.hasAttribute('data-type')) {
        this.type = root.getAttribute('data-type');
      }

      if (root.hasAttribute('data-lang')) {
        currentLang = root.getAttribute('data-lang');
      }

      if (currentLang && langs.indexOf(currentLang) !== -1) {
        this.lang = currentLang;
      }
    }

    if (!currentLang && window.location.href.includes('/en/')) {
      this.lang = 'en';
    } else if (!currentLang) {
      this.lang = 'ru';
    }
  },
  mounted() {
    if (this.state === 'members') {
      this.events = undefined;
      this.getMembersData();
    } else if (this.state === 'events') {
      this.members = undefined;
      this.getEventsData();
    }
  },
};

</script>
